const YIELD_INFORMATION_PARAGRAPHS: string[] = [
    'asset.yield.paragraph.one',
    'asset.yield.paragraph.two',
    'asset.yield.paragraph.three',
]

export default YIELD_INFORMATION_PARAGRAPHS;